(function ($) {
  'use strict';

  window.A11yDialog = require('a11y-dialog');

  /**
   * A generic modal
   */
  class Modal {
    constructor (options) {
      // Create the dialog element and background
      var $modalHtml = $(`
      <div class="modal u-margin-top-0" aria-hidden="true" id="${options.id}Dialog">
        <div class="modal__background" tabindex="-1" data-a11y-dialog-hide></div>
      </div>
      `);

      // Add the content wrapper and close button
      var $modalContent = $(`
      <div class="modal__content u-margin-top-0" aria-labelledby="${options.id}DialogTitle" aria-describedby="${options.id}DialogDescription" role="dialog">
        <button class="modal__close" aria-label="Close this window" data-a11y-dialog-hide><i class="icon icon-cross"></i></button>
      </div>
      `);

      if (options.hasOwnProperty('title')) {
        $modalContent.append(`<h3 id="${options.id}DialogTitle" class="modal__title u-margin-top-0">${options.title}</h3>`);
      }

      if (options.hasOwnProperty('description')) {
        $modalContent.append(`<p id="${options.id}DialogDescription">${options.description}</p>`);
      }

      if (options.hasOwnProperty('buttons') && options.buttons.length > 0) {
        var $modalOptions = $(`<div class="modal__options">`);
        options.buttons.forEach((props) => {
          $modalOptions.append(this.addButton(props));
        });
        $modalContent.append($modalOptions);
      }

      $modalHtml.append($modalContent);
      $modalHtml.insertAfter(options.mainEl);

      this.dialog = new window.A11yDialog($modalHtml[0], options.mainEl);
    }

    show () {
      this.dialog.show();
    }

    hide() {
      this.dialog.hide();
    }

    addButton (props) {
      var $button = $(`<button type="button" class="modal__button btn">${props.text}</button>`);

      if (props.hasOwnProperty('className')) {
        $button.addClass(props.className);
      }

      if (props.hasOwnProperty('close') && props.close === true) {
        $button.attr('data-a11y-dialog-hide', true);
      }

      if (props.hasOwnProperty('callback')) {
        $button.on('click', props.callback);
      }

      return $button;
    }
  }

  this.Modal = Modal;
}).call(Framework, jQuery);
